//@flow
import { urlsConstants } from './../_constants/urls.constant';
import { defaultService } from './defaultService';

export const empresaFinanceiroService = {
  doGet,
  doSave,
  findByFiltro,
  exportToExcel,
  findAll,

};

function findAll() {
  return defaultService.doGet(`${urlsConstants.EMPRESA}findAll`);
}

function findByFiltro(options: Options, filter: any): Promise<Array<>> {
  return defaultService.findByFiltro(
    `${urlsConstants.EMPRESA}financeiro/list`,
    options,
    filter
  );
}

function doGet(id) {
  return defaultService.doGet(`${urlsConstants.EMPRESA}/${id}`);
}

function doSave(entity: any) {
  return defaultService.doSave(urlsConstants.EMPRESA, entity);
}

function exportToExcel(filter, fields, labels) {
  return defaultService.exportToExcel('empresa', filter, fields, labels);
}
